import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-6 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-1" };
const _hoisted_3 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_4 = { class: "text-sm text-eblack-500" };
const _hoisted_5 = {
    key: 0,
    class: "flex flex-col gap-3 rounded-lg border border-ewhite-200 bg-white p-4 lg:flex-row lg:items-end"
};
const _hoisted_6 = { class: "flex flex-1 flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_7 = { value: "" };
const _hoisted_8 = { value: "published" };
const _hoisted_9 = { value: "hidden" };
const _hoisted_10 = { class: "flex flex-1 flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_11 = { value: "" };
const _hoisted_12 = ["value"];
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-3" };
const _hoisted_15 = { class: "flex flex-col gap-1.5 rounded-lg border border-ewhite-200 bg-white p-5" };
const _hoisted_16 = { class: "text-sm text-eblack-500" };
const _hoisted_17 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_18 = { class: "flex flex-col gap-1.5 rounded-lg border border-ewhite-200 bg-white p-5" };
const _hoisted_19 = { class: "text-sm text-eblack-500" };
const _hoisted_20 = { class: "text-2xl font-bold text-amber-500" };
const _hoisted_21 = { class: "flex flex-col gap-1.5 rounded-lg border border-ewhite-200 bg-white p-5" };
const _hoisted_22 = { class: "text-sm text-eblack-500" };
const _hoisted_23 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_24 = {
    key: 1,
    class: "rounded-lg border border-ewhite-200 bg-white p-8 text-center text-sm text-eblack-500"
};
const _hoisted_25 = {
    key: 2,
    class: "rounded-lg border border-red-200 bg-red-50 p-8 text-center text-sm text-red-700"
};
const _hoisted_26 = {
    key: 3,
    class: "flex flex-col items-center gap-2 rounded-lg border border-ewhite-200 bg-white p-12 text-center"
};
const _hoisted_27 = { class: "font-semibold text-eblack-700" };
const _hoisted_28 = { class: "max-w-xs text-sm text-eblack-400" };
const _hoisted_29 = {
    key: 4,
    class: "overflow-hidden rounded-lg border border-ewhite-200 bg-white"
};
const _hoisted_30 = { class: "overflow-x-auto" };
const _hoisted_31 = { class: "w-full min-w-[980px] text-sm" };
const _hoisted_32 = { class: "border-b border-ewhite-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-eblack-500" };
const _hoisted_33 = { class: "w-32 px-4 py-3" };
const _hoisted_34 = { class: "px-4 py-3" };
const _hoisted_35 = {
    key: 0,
    class: "px-4 py-3"
};
const _hoisted_36 = { class: "w-24 px-4 py-3" };
const _hoisted_37 = { class: "w-72 px-4 py-3" };
const _hoisted_38 = { class: "w-80 px-4 py-3" };
const _hoisted_39 = { class: "w-32 px-4 py-3" };
const _hoisted_40 = { class: "w-36 px-4 py-3" };
const _hoisted_41 = { class: "divide-y divide-ewhite-100" };
const _hoisted_42 = { class: "px-4 py-4 text-eblack-500" };
const _hoisted_43 = { class: "px-4 py-4" };
const _hoisted_44 = { class: "font-medium text-eblack-900" };
const _hoisted_45 = {
    key: 0,
    class: "px-4 py-4 text-eblack-600"
};
const _hoisted_46 = { class: "px-4 py-4" };
const _hoisted_47 = { class: "font-semibold text-amber-500" };
const _hoisted_48 = { class: "px-4 py-4 text-eblack-600" };
const _hoisted_49 = { class: "max-w-md whitespace-pre-line" };
const _hoisted_50 = { class: "px-4 py-4" };
const _hoisted_51 = {
    key: 0,
    class: "flex flex-col gap-2"
};
const _hoisted_52 = ["onUpdate:modelValue", "placeholder", "disabled"];
const _hoisted_53 = { class: "flex flex-wrap gap-2" };
const _hoisted_54 = ["disabled", "title", "onClick"];
const _hoisted_55 = ["disabled", "title", "onClick"];
const _hoisted_56 = {
    key: 1,
    class: "flex flex-col gap-1"
};
const _hoisted_57 = {
    key: 1,
    class: "text-eblack-400"
};
const _hoisted_58 = { class: "px-4 py-4" };
const _hoisted_59 = { class: "px-4 py-4" };
const _hoisted_60 = {
    key: 0,
    class: "flex flex-wrap gap-2"
};
const _hoisted_61 = ["disabled", "title", "onClick"];
const _hoisted_62 = ["disabled", "title", "onClick"];
const _hoisted_63 = {
    key: 1,
    class: "text-eblack-400"
};
import { computed, reactive, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { IconDeviceFloppy, IconEye, IconEyeOff, IconRefresh, IconStar, IconTrash, } from "@tabler/icons-vue";
import posthog from "posthog-js";
import ConfirmModal from "@/components/ui/ConfirmModal.vue";
import { useAbility, useAuthStore } from "@/domains/auth";
import { useProviderReviewStore } from "@/domains/reviews/stores";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReviewsIndex',
    setup(__props) {
        const route = useRoute();
        const { t } = useI18n();
        const { can } = useAbility();
        const authStore = useAuthStore();
        const reviewStore = useProviderReviewStore();
        const { reviews, isLoadingReviews, reviewsError, totalReviews, averageRating, reviewsThisMonth, } = storeToRefs(reviewStore);
        const replyDrafts = reactive({});
        const busyAction = ref(null);
        const pendingAction = ref(null);
        const filters = reactive({
            status: "",
            rating: "",
        });
        const isGlobalReviewManager = computed(() => route.path.startsWith("/admin/global/reviews"));
        const readScope = computed(() => authStore.currentOrgType === "concierge" ? "concierge" : "provider");
        const canManageProviderReply = computed(() => authStore.currentOrgType === "provider" &&
            (can("create", "Review") ||
                can("update", "Review") ||
                can("manage", "Review")));
        const pageTitleKey = computed(() => {
            if (isGlobalReviewManager.value)
                return "reviews.global.title";
            if (readScope.value === "concierge")
                return "reviews.concierge.title";
            return "reviews.provider.title";
        });
        const pageDescriptionKey = computed(() => {
            if (isGlobalReviewManager.value)
                return "reviews.global.description";
            if (readScope.value === "concierge")
                return "reviews.concierge.description";
            return "reviews.provider.description";
        });
        watch(() => [route.path, authStore.currentOrgId, authStore.currentOrgType], () => void loadReviews(), { immediate: true });
        watch(reviews, () => {
            for (const review of reviews.value) {
                const id = reviewKey(review);
                if (id > 0 && replyDrafts[id] === undefined) {
                    replyDrafts[id] = review.provider_reply?.body ?? "";
                }
            }
        }, { immediate: true });
        async function loadReviews() {
            if (isGlobalReviewManager.value) {
                await reviewStore.fetchPlatformReviews({
                    limit: 100,
                    status: filters.status,
                    rating: filters.rating ? Number(filters.rating) : undefined,
                });
            }
            else {
                await reviewStore.fetchReviews(readScope.value);
            }
            posthog.capture("admin_reviews_loaded", {
                count: reviews.value.length,
                mode: isGlobalReviewManager.value ? "global" : readScope.value,
            });
        }
        function reviewKey(review) {
            return review.review_id ?? review.id ?? 0;
        }
        function formatDate(dateStr) {
            try {
                return new Intl.DateTimeFormat(undefined, {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                }).format(new Date(dateStr));
            }
            catch {
                return dateStr;
            }
        }
        function hasDraft(review) {
            return (replyDrafts[reviewKey(review)] ?? "").trim().length > 0;
        }
        function isReviewActionBusy(reviewId) {
            return busyAction.value?.startsWith(`${reviewId}:`) ?? false;
        }
        async function saveReply(review) {
            const id = reviewKey(review);
            const body = (replyDrafts[id] ?? "").trim();
            if (!id || body.length === 0)
                return;
            busyAction.value = `${id}:reply`;
            try {
                await reviewStore.saveProviderReply(id, body);
                replyDrafts[id] = body;
            }
            finally {
                busyAction.value = null;
            }
        }
        function requestDeleteReply(review) {
            const id = reviewKey(review);
            if (!id)
                return;
            pendingAction.value = { kind: "delete-reply", review };
        }
        async function toggleReviewModeration(review) {
            const id = reviewKey(review);
            if (!id)
                return;
            if (reviewHidden(review)) {
                busyAction.value = `${id}:moderation`;
                try {
                    await reviewStore.moderateReview(id, "restore");
                }
                finally {
                    busyAction.value = null;
                }
                return;
            }
            pendingAction.value = { kind: "hide-review", review };
        }
        async function toggleReplyModeration(review) {
            const id = reviewKey(review);
            const replyId = review.provider_reply?.id;
            if (!id || !replyId)
                return;
            if (replyHidden(review)) {
                busyAction.value = `${id}:reply-moderation`;
                try {
                    await reviewStore.moderateReply(replyId, "restore");
                }
                finally {
                    busyAction.value = null;
                }
                return;
            }
            pendingAction.value = { kind: "hide-reply", review };
        }
        async function confirmPendingAction(reason) {
            const action = pendingAction.value;
            if (!action)
                return;
            const id = reviewKey(action.review);
            try {
                if (action.kind === "delete-reply") {
                    busyAction.value = `${id}:reply`;
                    await reviewStore.deleteProviderReply(id);
                    replyDrafts[id] = "";
                }
                else if (action.kind === "hide-review") {
                    busyAction.value = `${id}:moderation`;
                    await reviewStore.moderateReview(id, "hide", reason || undefined);
                }
                else if (action.kind === "hide-reply") {
                    const replyId = action.review.provider_reply?.id;
                    if (replyId) {
                        busyAction.value = `${id}:reply-moderation`;
                        await reviewStore.moderateReply(replyId, "hide", reason || undefined);
                    }
                }
            }
            finally {
                busyAction.value = null;
                pendingAction.value = null;
            }
        }
        function cancelPendingAction() {
            pendingAction.value = null;
        }
        function reviewHidden(review) {
            return review.moderation_status === "hidden";
        }
        function replyHidden(review) {
            return Boolean(review.provider_reply &&
                (review.provider_reply.status === "hidden" ||
                    review.provider_reply.hidden_at));
        }
        function statusLabelKey(status) {
            return status === "hidden"
                ? "reviews.status.hidden"
                : "reviews.status.published";
        }
        function statusBadgeClass(status) {
            return status === "hidden"
                ? "bg-slate-100 text-eblack-500"
                : "bg-emerald-50 text-emerald-700";
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)(pageTitleKey.value)), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)(pageDescriptionKey.value)), 1)
                ]),
                (isGlobalReviewManager.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)("reviews.global.filters.status")), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.status) = $event)),
                                class: "h-10 rounded-md border border-ewhite-300 bg-white px-3 text-sm text-eblack-800 focus:border-eorange-400 focus:outline-none focus:ring-2 focus:ring-eorange-200"
                            }, [
                                _createElementVNode("option", _hoisted_7, _toDisplayString(_unref(t)("reviews.global.filters.all_statuses")), 1),
                                _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)("reviews.status.published")), 1),
                                _createElementVNode("option", _hoisted_9, _toDisplayString(_unref(t)("reviews.status.hidden")), 1)
                            ], 512), [
                                [_vModelSelect, filters.status]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)("reviews.global.filters.rating")), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filters.rating) = $event)),
                                class: "h-10 rounded-md border border-ewhite-300 bg-white px-3 text-sm text-eblack-800 focus:border-eorange-400 focus:outline-none focus:ring-2 focus:ring-eorange-200"
                            }, [
                                _createElementVNode("option", _hoisted_11, _toDisplayString(_unref(t)("reviews.global.filters.all_ratings")), 1),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 4, 3, 2, 1], (rating) => {
                                    return _createElementVNode("option", {
                                        key: rating,
                                        value: String(rating)
                                    }, _toDisplayString(rating) + " ★ ", 9, _hoisted_12);
                                }), 64))
                            ], 512), [
                                [_vModelSelect, filters.rating]
                            ])
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex h-10 items-center justify-center gap-2 rounded-md bg-eblack-900 px-4 text-sm font-semibold text-white transition-colors hover:bg-eblack-800 disabled:cursor-not-allowed disabled:bg-eblack-300",
                            disabled: _unref(isLoadingReviews),
                            onClick: loadReviews
                        }, [
                            _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)("reviews.global.filters.apply")), 1)
                        ], 8, _hoisted_13)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("reviews.provider.stats.total")), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(totalReviews)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)("reviews.provider.stats.average")), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(averageRating)) + " ★", 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)("reviews.provider.stats.this_month")), 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(reviewsThisMonth)), 1)
                    ])
                ]),
                (_unref(isLoadingReviews))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)("reviews.provider.loading")), 1))
                    : (_unref(reviewsError))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(reviewsError)), 1))
                        : (_unref(reviews).length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createVNode(_unref(IconStar), { class: "h-10 w-10 text-eblack-300" }),
                                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)("reviews.provider.empty.title")), 1),
                                _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(t)("reviews.provider.empty.description")), 1)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("table", _hoisted_31, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", _hoisted_32, [
                                                _createElementVNode("th", _hoisted_33, _toDisplayString(_unref(t)("reviews.provider.table.date")), 1),
                                                _createElementVNode("th", _hoisted_34, _toDisplayString(_unref(t)("reviews.provider.table.service")), 1),
                                                (isGlobalReviewManager.value)
                                                    ? (_openBlock(), _createElementBlock("th", _hoisted_35, _toDisplayString(_unref(t)("reviews.provider.table.provider")), 1))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("th", _hoisted_36, _toDisplayString(_unref(t)("reviews.provider.table.rating")), 1),
                                                _createElementVNode("th", _hoisted_37, _toDisplayString(_unref(t)("reviews.provider.table.comment")), 1),
                                                _createElementVNode("th", _hoisted_38, _toDisplayString(_unref(t)("reviews.provider.table.reply")), 1),
                                                _createElementVNode("th", _hoisted_39, _toDisplayString(_unref(t)("reviews.provider.table.status")), 1),
                                                _createElementVNode("th", _hoisted_40, _toDisplayString(_unref(t)("reviews.provider.table.actions")), 1)
                                            ])
                                        ]),
                                        _createElementVNode("tbody", _hoisted_41, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reviews), (review) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: reviewKey(review),
                                                    class: _normalizeClass(["align-top transition-colors hover:bg-slate-50",
                                                        reviewHidden(review) ? 'bg-slate-50/70 text-eblack-400' : ''
                                                    ])
                                                }, [
                                                    _createElementVNode("td", _hoisted_42, _toDisplayString(formatDate(review.date)), 1),
                                                    _createElementVNode("td", _hoisted_43, [
                                                        _createElementVNode("p", _hoisted_44, _toDisplayString(review.service_name), 1)
                                                    ]),
                                                    (isGlobalReviewManager.value)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(review.provider_name ||
                                                            _unref(t)("reviews.provider.table.unknown_provider")), 1))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("td", _hoisted_46, [
                                                        _createElementVNode("span", _hoisted_47, _toDisplayString(review.rating) + " ★", 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_48, [
                                                        _createElementVNode("p", _hoisted_49, _toDisplayString(review.comment || "—"), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_50, [
                                                        (canManageProviderReply.value && !isGlobalReviewManager.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                                _withDirectives(_createElementVNode("textarea", {
                                                                    "onUpdate:modelValue": ($event) => ((replyDrafts[reviewKey(review)]) = $event),
                                                                    class: "min-h-24 resize-y rounded-md border border-ewhite-300 px-3 py-2 text-sm text-eblack-800 focus:border-eorange-400 focus:outline-none focus:ring-2 focus:ring-eorange-200",
                                                                    placeholder: _unref(t)('reviews.provider.reply.placeholder'),
                                                                    disabled: isReviewActionBusy(reviewKey(review))
                                                                }, null, 8, _hoisted_52), [
                                                                    [_vModelText, replyDrafts[reviewKey(review)]]
                                                                ]),
                                                                _createElementVNode("div", _hoisted_53, [
                                                                    _createElementVNode("button", {
                                                                        type: "button",
                                                                        class: "inline-flex items-center gap-1.5 rounded-md bg-eblack-900 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-eblack-800 disabled:cursor-not-allowed disabled:bg-eblack-300",
                                                                        disabled: isReviewActionBusy(reviewKey(review)) ||
                                                                            !hasDraft(review),
                                                                        title: _unref(t)('reviews.provider.reply.save'),
                                                                        onClick: ($event) => (saveReply(review))
                                                                    }, [
                                                                        _createVNode(_unref(IconDeviceFloppy), { class: "h-4 w-4" }),
                                                                        _createElementVNode("span", null, _toDisplayString(_unref(t)("reviews.provider.reply.save")), 1)
                                                                    ], 8, _hoisted_54),
                                                                    (review.provider_reply)
                                                                        ? (_openBlock(), _createElementBlock("button", {
                                                                            key: 0,
                                                                            type: "button",
                                                                            class: "inline-flex items-center gap-1.5 rounded-md border border-red-200 px-3 py-2 text-xs font-semibold text-red-700 transition-colors hover:bg-red-50 disabled:cursor-not-allowed disabled:text-red-300",
                                                                            disabled: isReviewActionBusy(reviewKey(review)),
                                                                            title: _unref(t)('reviews.provider.reply.delete'),
                                                                            onClick: ($event) => (requestDeleteReply(review))
                                                                        }, [
                                                                            _createVNode(_unref(IconTrash), { class: "h-4 w-4" }),
                                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("reviews.provider.reply.delete")), 1)
                                                                        ], 8, _hoisted_55))
                                                                        : _createCommentVNode("", true)
                                                                ])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                                (review.provider_reply)
                                                                    ? (_openBlock(), _createElementBlock("p", {
                                                                        key: 0,
                                                                        class: _normalizeClass(["max-w-md whitespace-pre-line text-eblack-600",
                                                                            replyHidden(review) ? 'text-eblack-400 line-through' : ''
                                                                        ])
                                                                    }, _toDisplayString(review.provider_reply.body), 3))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_unref(t)("reviews.provider.reply.empty")), 1))
                                                            ]))
                                                    ]),
                                                    _createElementVNode("td", _hoisted_58, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["inline-flex rounded-full px-2.5 py-1 text-xs font-semibold", statusBadgeClass(review.moderation_status)])
                                                        }, _toDisplayString(_unref(t)(statusLabelKey(review.moderation_status))), 3)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_59, [
                                                        (isGlobalReviewManager.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    class: "inline-flex items-center gap-1.5 rounded-md border border-ewhite-300 px-3 py-2 text-xs font-semibold text-eblack-700 transition-colors hover:bg-ewhite-100 disabled:cursor-not-allowed disabled:text-eblack-300",
                                                                    disabled: isReviewActionBusy(reviewKey(review)),
                                                                    title: reviewHidden(review)
                                                                        ? _unref(t)('reviews.global.actions.restore_review')
                                                                        : _unref(t)('reviews.global.actions.hide_review'),
                                                                    onClick: ($event) => (toggleReviewModeration(review))
                                                                }, [
                                                                    (reviewHidden(review))
                                                                        ? (_openBlock(), _createBlock(_unref(IconEye), {
                                                                            key: 0,
                                                                            class: "h-4 w-4"
                                                                        }))
                                                                        : (_openBlock(), _createBlock(_unref(IconEyeOff), {
                                                                            key: 1,
                                                                            class: "h-4 w-4"
                                                                        })),
                                                                    _createElementVNode("span", null, _toDisplayString(reviewHidden(review)
                                                                        ? _unref(t)("reviews.global.actions.restore")
                                                                        : _unref(t)("reviews.global.actions.hide")), 1)
                                                                ], 8, _hoisted_61),
                                                                (review.provider_reply)
                                                                    ? (_openBlock(), _createElementBlock("button", {
                                                                        key: 0,
                                                                        type: "button",
                                                                        class: "inline-flex items-center gap-1.5 rounded-md border border-ewhite-300 px-3 py-2 text-xs font-semibold text-eblack-700 transition-colors hover:bg-ewhite-100 disabled:cursor-not-allowed disabled:text-eblack-300",
                                                                        disabled: isReviewActionBusy(reviewKey(review)),
                                                                        title: replyHidden(review)
                                                                            ? _unref(t)('reviews.global.actions.restore_reply')
                                                                            : _unref(t)('reviews.global.actions.hide_reply'),
                                                                        onClick: ($event) => (toggleReplyModeration(review))
                                                                    }, [
                                                                        (replyHidden(review))
                                                                            ? (_openBlock(), _createBlock(_unref(IconEye), {
                                                                                key: 0,
                                                                                class: "h-4 w-4"
                                                                            }))
                                                                            : (_openBlock(), _createBlock(_unref(IconEyeOff), {
                                                                                key: 1,
                                                                                class: "h-4 w-4"
                                                                            })),
                                                                        _createElementVNode("span", null, _toDisplayString(replyHidden(review)
                                                                            ? _unref(t)("reviews.global.actions.restore_reply_short")
                                                                            : _unref(t)("reviews.global.actions.hide_reply_short")), 1)
                                                                    ], 8, _hoisted_62))
                                                                    : _createCommentVNode("", true)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_63, "—"))
                                                    ])
                                                ], 2));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ])),
                (pendingAction.value?.kind === 'delete-reply')
                    ? (_openBlock(), _createBlock(ConfirmModal, {
                        key: 5,
                        title: _unref(t)('reviews.provider.reply.delete_confirm_title'),
                        message: _unref(t)('reviews.provider.reply.delete_confirm'),
                        "confirm-text": _unref(t)('common.actions.confirm'),
                        "cancel-text": _unref(t)('common.actions.cancel'),
                        variant: "danger",
                        "data-test": "review-delete-reply-confirm",
                        onConfirm: confirmPendingAction,
                        onCancel: cancelPendingAction
                    }, null, 8, ["title", "message", "confirm-text", "cancel-text"]))
                    : (pendingAction.value)
                        ? (_openBlock(), _createBlock(ConfirmModal, {
                            key: 6,
                            title: _unref(t)('reviews.global.actions.reason_prompt_title'),
                            message: _unref(t)('reviews.global.actions.reason_prompt'),
                            "with-reason": "",
                            "reason-label": _unref(t)('reviews.global.actions.reason_label'),
                            "confirm-text": _unref(t)('common.actions.confirm'),
                            "cancel-text": _unref(t)('common.actions.cancel'),
                            variant: "danger",
                            "data-test": "review-moderation-confirm",
                            onConfirm: confirmPendingAction,
                            onCancel: cancelPendingAction
                        }, null, 8, ["title", "message", "reason-label", "confirm-text", "cancel-text"]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
